// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_EDIT_SUBMIT_HELP = "E\u0161te nem\u00e1\u0161 vyplnen\u00e9 v\u0161etko.";
export const CANCEL = "Zru\u0161";
export const DELETE = "Zma\u017e";
export const DELETION_ENTER_REASON = "Nap\u00ed\u0161 d\u00f4vod zmazania";
